const hostname = window.location.hostname;

const AVC_DEV_URL = process.env.REACT_APP_NEW_DEV;
const AVC_PROD_URL = process.env.REACT_APP_NEW_PROD;
const API_DEV_HOSTS = process.env.REACT_APP_API_DEV_HOSTS || '';

const devHosts = API_DEV_HOSTS.split(',')
	.map((host) => host.trim())
	.filter(Boolean);

const AVC_BASE_URL = devHosts.includes(hostname)
	? AVC_DEV_URL
	: AVC_PROD_URL;

export default AVC_BASE_URL;
